export default __webpack_public_path__ + "static/media/gallery - story - fountain (1)_00.09f38dc3.jpg";